import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Standard dialog configuration for dark theme dialogs.
 * Use this as a base configuration for all MatDialog.open() calls.
 */
export const DIALOG_CONFIG: MatDialogConfig = {
  panelClass: 'dark-dialog',
  autoFocus: false,
  restoreFocus: true,
};

/**
 * Creates a dialog config with custom overrides.
 * @param overrides Custom configuration to merge
 * @returns Combined dialog configuration
 */
export function createDialogConfig(overrides?: Partial<MatDialogConfig>): MatDialogConfig {
  return {
    ...DIALOG_CONFIG,
    ...overrides,
  };
}

/**
 * Standard dialog configuration for small dialogs (400px width).
 */
export const SMALL_DIALOG_CONFIG: MatDialogConfig = {
  ...DIALOG_CONFIG,
  width: '400px',
  maxWidth: '95vw',
};

/**
 * Standard dialog configuration for medium dialogs (600px width).
 */
export const MEDIUM_DIALOG_CONFIG: MatDialogConfig = {
  ...DIALOG_CONFIG,
  width: '600px',
  maxWidth: '95vw',
};

/**
 * Standard dialog configuration for large dialogs (800px width).
 */
export const LARGE_DIALOG_CONFIG: MatDialogConfig = {
  ...DIALOG_CONFIG,
  width: '800px',
  maxWidth: '95vw',
};

/**
 * Standard dialog configuration for extra large dialogs (1000px width).
 */
export const XL_DIALOG_CONFIG: MatDialogConfig = {
  ...DIALOG_CONFIG,
  width: '1000px',
  maxWidth: '95vw',
};

/**
 * Standard dialog configuration for full-screen dialogs.
 */
export const FULLSCREEN_DIALOG_CONFIG: MatDialogConfig = {
  ...DIALOG_CONFIG,
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  panelClass: ['dark-dialog', 'fullscreen-dialog'],
};

/**
 * Dialog configuration for confirmation dialogs.
 */
export const CONFIRM_DIALOG_CONFIG: MatDialogConfig = {
  ...SMALL_DIALOG_CONFIG,
  disableClose: true,
};

/**
 * Dialog configuration for form dialogs that should not close on backdrop click.
 */
export const FORM_DIALOG_CONFIG: MatDialogConfig = {
  ...MEDIUM_DIALOG_CONFIG,
  disableClose: true,
};
